module.exports = __webpack_public_path__ + "static/media/tools-line-size.67b3a68e.svg";